// extracted by mini-css-extract-plugin
export default {"wrapper":"item-overview_wrapper__Zz768","header":"item-overview_header__c8FOw"};